import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const createUser = async (
  params: CreateUpdateUserRequest
) => {
  await api.post("/users/", { body: params })
  queryClient.invalidateQueries([BASE_USERS_QUERY_KEY])
}
